import React from "react";
import webui from "@tinqin/tinqin-web-ui";
import { xssFilter } from "../../common/utils/xssFilter";
import EntityBuilder from "@tinqin/tinqin-web-ui/src/utils/EntityBuilder";

//temp component, before html is refactored
const getLogoProperties = (dataEntity, name) => {
    const entity = dataEntity.getChild(name);
    return {
        src: entity.getProperty("src") || "",
        alt: entity.getProperty("alt") || ""
    };
};
function TitleImage(props) {
    const data = props.data ? props.data.properties || {} : null;
    if (!data) {
        return "";
    }
    const dataEntity = EntityBuilder.of(props.data, { inplace: true });
    const logos = [
        getLogoProperties(dataEntity, "logoMain"),
        getLogoProperties(dataEntity, "logoPartner")
    ];
    const dataProps = webui.getUtils().extractComponentProps(props, {
        additionalProps: ["src", "alt", "title"],
        aliases: { title: "text" }
    });

    return (
        <div
            className="tq-panel tq-card tq-bgimg-card un-article-hero-box"
            style={{
                backgroundImage: `url("${dataProps.src}")`
            }}
        >
            <header>
                <i className="tq-icon-map-2 tq-card-icon" />
            </header>
            {logos[0].src && (
                <div className="un-cp-logos">
                    {logos.map((logo, i) => (
                        <img key={i} src={logo.src} alt={logo.alt} />
                    ))}
                </div>
            )}
            <div className="tq-card-content">
                <p
                    className="tq-paragraph"
                    dangerouslySetInnerHTML={{
                        __html: xssFilter.process(dataProps.title)
                    }}
                    data-hyperlinks-container={true}
                ></p>
            </div>
        </div>
    );
}

export default webui.connectComponent()(TitleImage);
